import supportModule from '../../support.module';

class SupportViewCaseService {
    constructor($q, asNotifier, supportCaseApiService, supportCaseFeedApiService, supportConfigApiService, textResources, stateConstants) {
        this.$q = $q;
        this.asNotifier = asNotifier;
        this.supportCaseApiService = supportCaseApiService;
        this.supportCaseFeedApiService = supportCaseFeedApiService;
        this.supportConfigApiService = supportConfigApiService;
        this.textResources = textResources;

        this.commentConfig;

        this.case;
        this.limit = 5;
        this.paths = [
            { label: this.textResources.supportCaseHistoryTitle, sref: stateConstants.support.overview.name, value: stateConstants.support.overview.name },
            { label: '' }
        ];
        this.loadedComments = [];
    }

    loadCase(id) {
        var deferred = this.$q.defer();

        this.getCase(id).then(
            data => {
                this.paths[1].label = data.id;
                this.clearCase();
                this.case = data;
                this.loadComments();
                deferred.resolve(data);
            },
            data => {
                this.asNotifier.error(this.textResources.caseNotFound);
                deferred.reject(data);
            }
        );

        return deferred.promise;
    }

    clearCase() {
        this.case = null;
        this.loadedComments = [];
    }

    getCase(id) {
        var deferred = this.$q.defer();

        this.supportCaseApiService.getCase(id).then(data => {
            data.dynamicFields = data.fields;
            if (data.attachments && data.attachments.length > 0) {
                data.dynamicFields.push({
                    label: 'Attachments',
                    name: 'attachments',
                    value: data.attachments.map(attachment => {
                        return {
                            value: attachment.filename,
                            href: attachment.href
                        };
                    })
                });
                delete data.attachments;
            }
            delete data.attachments;
            deferred.resolve(data);
        }, deferred.reject);

        return deferred.promise;
    }

    getCommentConfig() {
        if (this.commentConfig) {
            return this.$q.resolve(this.commentConfig);
        }

        var deferred = this.$q.defer();

        this.supportConfigApiService.getCaseCommentConfig().then(data => {
            if (data.fields) {
                data.fields = data.fields.reduce((obj, item) => {
                    obj[item.name] = item;
                    delete item.name;
                    return obj;
                }, {});
                this.commentConfig = data.fields;
                deferred.resolve(data.fields);
                return;
            }
            deferred.reject(data);
        }, deferred.reject);

        return deferred.promise;
    }

    loadComments() {
        if (!this.case) {
            return;
        }

        if (this.loadedComments.length < this.case.feed.length) {
            this.loadedComments = this.loadedComments.concat(this.case.feed.slice(this.loadedComments.length, this.loadedComments.length + this.limit));
        }
    }

    submitComment(caseid, comment, attachment, resolveCase) {
        var fd = new FormData();

        if (comment) {
            fd.append('body', comment);
        }
        if (attachment) {
            fd.append('attachment', attachment);
        }
        if (typeof resolveCase === 'boolean') {
            fd.append('resolve', resolveCase);
        }

        return this.supportCaseFeedApiService.postCaseComment(caseid, fd);
    }
}

export default supportModule.service('supportViewCaseService', SupportViewCaseService);



// WEBPACK FOOTER //
// ./modules/support/services/supportViewCase/supportViewCase.service.js